import { Vector3 } from 'three'

export function circlePoints(x1: number, y1: number, x2: number, y2: number, sampleCount: number = 27): Vector3[] {
  const circleWidth = Math.abs(x2 - x1)
  const circleHeight = Math.abs(y2 - y1)

  const points = []

  const centerX = (x1 + x2) / 2
  const centerY = (y1 + y2) / 2

  for (let i = 0; i < sampleCount - 1; i += 1) {
    const t = ((Math.PI * 2) / (sampleCount - 1)) * i
    const cx = (circleWidth / 2) * Math.cos(t)
    const cy = (circleHeight / 2) * Math.sin(t)
    points.push(new Vector3(cx + centerX, cy + centerY, 0))
  }

  return points
}
